"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logo = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const logo_style_1 = __importDefault(require("./logo.style"));
const logo_mark_1 = __importDefault(require("./logo.mark"));
const logo_text_1 = __importDefault(require("./logo.text"));
class Logo extends react_1.Component {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, size, fill, axis } = this.props;
            const style = {
                width: axis === 'x' ? size : size * 5.071428571,
                height: axis === 'x' ? size / 5.071428571 : size
            };
            return (jsx_runtime_1.jsxs("div", Object.assign({ className: classes.root, style: style }, { children: [jsx_runtime_1.jsx("div", Object.assign({ className: classes.logoMark }, { children: jsx_runtime_1.jsx(logo_mark_1.default, { fill: fill, axis: "y" }, void 0) }), void 0),
                    jsx_runtime_1.jsx("div", Object.assign({ className: classes.logoText }, { children: jsx_runtime_1.jsx(logo_text_1.default, { fill: fill, axis: "y" }, void 0) }), void 0)] }), void 0));
        };
    }
}
exports.Logo = Logo;
Logo.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    size: prop_types_1.default.number,
    axis: prop_types_1.default.oneOf(['x', 'y']),
    fill: prop_types_1.default.bool
};
Logo.defaultProps = {
    size: 106,
    axis: 'x',
    fill: false
};
exports.default = react_jss_1.default(logo_style_1.default)(Logo);
//# sourceMappingURL=logo.js.map